<div class="tw-flex">
  <div class="tw-w-full">
    <div class="tw-flex tw-justify-between">
      <h3>{{ 'lang.globals.columns' |translate }}</h3>
      <input [(ngModel)]="columnSearch" class="tw-input"
             placeholder="{{'lang.globals.searchPlaceholder' | translate}}"
             type="text">
    </div>
    <div class="tw-h-[400px] tw-overflow-auto tw-border tw-border-solid tw-border-sbGray-900 tw-mt-3">
      @let sortedColumns = getSortedColumns();
      <table class="table table-hover">
        <tbody>
          @for (item of sortedColumns | filter: columnSearch; track item.id) {
            @if (!item.selected) {
              <tr class="tw-cursor-pointer *:!tw-px-1" (click)="addToSelectedColumns(item)">
                <td>
                  <sb-icon icon="plus" class="tw-text-sbGreen-500"></sb-icon>
                </td>
                <td>
                  <div class="tw-flex tw-gap-2">
                    <sb-icon [icon]="getColumnIcon(item)"></sb-icon>
                    <div>

                    {{ item?.title | translate }}
                    </div>
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
  <!-- separator -->
  <div class="tw-mx-6 tw-flex tw-justify-center tw-items-center">>></div>
  <!-- separator -->
  <div class="tw-w-full">
    <div class="tw-flex tw-justify-between">
      <h3>{{ 'lang.globals.selectedColumns' |translate }} ({{ selectedColumns?.length ?? 0 }})</h3>
      <div class="tw-flex tw-gap-2.5">
        <button
          (click)="columnsSelectNone()"
          type="button"
          sb-button-primary
          color="blue"
          icon="box"
          size="small"
          [iconButton]="true"
          container="body" sbTooltip="{{'lang.globals.selectNone' | translate}}"
        >
        </button>
        <button
          (click)="columnsRestoreDefault()"

          type="button"
          sb-button-primary
          color="blue"
          icon="undo"
          size="small"
          [iconButton]="true"
          container="body" sbTooltip="{{'lang.globals.restoreDefaultColumns' | translate}}"
        >
        </button>
      </div>
    </div>
    <div class="tw-h-[400px] tw-overflow-auto tw-border tw-border-solid tw-border-sbGray-900 tw-mt-3">
      <table class="table">
        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          @for (selectedItem of selectedColumns; track selectedItem.id; let index = $index) {
            <tr class="tw-cursor-pointer *:!tw-px-1" cdkDrag cdkDragLockAxis="y">
              <td>
                <sb-icon icon="minus" class="tw-text-sbRed-500" (click)="removeFromSelectedColumns(selectedItem, index)"></sb-icon>
              </td>
              <td cdkDragHandle>
                <div class="tw-flex tw-justify-between">
                  <div class="tw-flex tw-gap-2">
                    <sb-icon [icon]="getColumnIcon(selectedItem)"></sb-icon>
                  <div>{{ selectedItem?.title | translate }}</div>
                  </div>
                  <sb-icon icon="drag" class="tw-text-sbBlue-500 tw-mr-2" cdkDragHandle></sb-icon>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
<div class="tw-flex tw-justify-between tw-mt-2">
  <button type="button" sb-button-primary [color]="'red'" [icon]="'cancel'"
          (click)="cancelColumnOptions()">{{ 'lang.globals.cancel'|translate }}
  </button>
  <button type="button" sb-button-primary [color]="'blue'" [icon]="'save'"
          (click)="submitColumnOptions()">{{ 'lang.globals.save'|translate }}
  </button>
</div>
